import { Component } from '@angular/core';

import { DialogBodyComponent, DialogComponent } from '@core/user-interface-legacy';

@Component({
  template: `
    <rt-dialog-body>
      {{ name }}
      <button (click)="close()">Close</button>
    </rt-dialog-body>
  `,
  imports: [DialogBodyComponent],
})
export class InputOnlyDialogComponent extends DialogComponent<{ name: string }> {
  public name = this.dialogData.name;

  public close() {
    this.dialogRef.close({ anything: 'anything allowed' });
  }
}
